import React from 'react'
import styled from 'styled-components'
import checked from '../../../images/refund-status-tele/checked.svg';
import unchecked from '../../../images/refund-status-tele/unchecked.svg';

const OuterContainer = styled.div`
  display: flex;
  gap: 8px;
  border-radius: 12px;
  border: 1px solid
    ${({ isSelected }) => (isSelected ? 'var(--primary-button)' : '#E3E3E3')};
  opacity: 0px;
  padding: 10px;
  align-items: center;
`;

const Text = styled.p`
font-size: 12px;
font-weight: 600;
line-height: 18px;
text-align: left;
`;

const Choice = ({ choice, isSelected, onClick }) => {
  return (
    <OuterContainer isSelected={isSelected} onClick={onClick}>
        {
            isSelected ? (
                <>
                    <img src={checked} alt='checkbox' style={{cursor: 'pointer'}}/>
                    <Text>{choice}</Text>
                </>
            ) : (
                <>
                    <img src={unchecked} alt='checkbox' style={{cursor: 'pointer'}}/>
                    <Text>{choice}</Text>
                </>
            )
        }
    </OuterContainer>
  )
}

export default Choice